import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/simples";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, nullOrEmpty } from "keautils";
import { validation, formfields } from "kea-react"
import { componentToRx } from "react-rxk";
import { fa } from "typed-font-awesome";
import { observeResource } from "kea-resource";

import { validarRFC, erroresValidarIdentificacion, erroresValidarIdentificacionNoRepetidos } from "app/logic/cliente";

type Entity = models.Identificacion;
export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void>;
    /**Datos que se le van a pasar al resource que comprueba si estan repetidos los datos */
    datosRep?: any;
    resourceRep?: resources.ResourceIdentificacionRepetido<any>;
    readonly?: boolean;
    error?: kea.FieldError;
    ocultarRFC?:boolean;
}

/**
* Componente para editar un Entity
*/
class IdentificacionComponentNoRx extends React.PureComponent<Props> {
    value = (props: Props) => this.props.value;
    datosRep = (props: Props) => this.props.datosRep;
    resourceRep = (props: Props) => this.props.resourceRep;

    errors = createSelectorRx(this.value, this.datosRep, this.resourceRep,
        (value, datosRep, resourceRep) => (datosRep != undefined && resourceRep != undefined) ?
            erroresValidarIdentificacion(value, datosRep, resourceRep) :
            erroresValidarIdentificacionNoRepetidos(value));

    getField = formfields(() => this.props, () => this.errors(this.props));

    get rules(): validation.Rules<Entity> {
        return {};
    }


    
     cambiorfc(cadena:string){ 
        const tipoPersona = 
            cadena.length == 12 ?  models.TipoPersona.Moral :
            cadena.length == 13 ?  models.TipoPersona.Fisica : 
            null;

        const nuevoObjeto: Entity = {
            ... this.props.value,
            Rfc: cadena,
            TipoPersona: tipoPersona
        };

        this.props.onChange(nuevoObjeto); 
    } 
   
    render() { 
        const { value } = this.props;
        const getField = this.getField;

        const Text = getField(kea.Text);
        const TipoPersona = getField(selectores.TipoPersona);
        const GiroEmpresa = getField(selectores.GiroEmpresa);
        const Clasificacion = getField(selectores.Clasificacion);
         
        const textoRfc=  this.props.ocultarRFC === true? " ": "RFC"; 
         return (
            <div> 
                <kea.Panel title="Identificacion" iconClass={fa("id-card-o")} error={this.props.error} style="success" >
                
                    {kea.autogrid(3, [
                        <Text field="Ine" label="INE" />, 
                        <Text field="Curp" label="CURP" />,
                        <Text field="Pasaporte" />, 
                        <Text field="Rfc" label={textoRfc}  onChange={x=>this.cambiorfc(x)} style= { { visibility: this.props.ocultarRFC === true? "hidden": "visible" }} />  
                    ])}

                    {
                        this.props.ocultarRFC != true && 
                        kea.autogrid(3, [
                            <TipoPersona field="TipoPersona" label={"Tipo de persona"} readonly />
                        ])
                    } 
                </kea.Panel>
            </div>);
    }
}

export const IdentificacionComponent = componentToRx(kea.mapProps(IdentificacionComponentNoRx, x => ({ ...x, value: x.value || {} })), <kea.Spinner />, undefined, {
    error: { ignore: { observable: true, promise: true } }
});


// WEBPACK FOOTER //
// ./app/features/componentes/cliente/identificacion.tsx